<template>
    <painel-component :itens="itensOne">
        <div class="filter-position" v-if="btnFilter">
            <button-one class="btn-filter" icon="filter" @click="filterWindow"/>
        </div>

        <form class="mb-4 mt-5">
            <transition name="fade-in-top">
                <row-component v-if="filter">
                    <row-col-component :class-row-col="'col-xxl-3 col-xl-3 col-lg-3 col-md-12 col-sm-12 col-12'">
                        <label>Nome:</label>
                        <input-component :type-input="'text'" v-model="formDate.name"/>
                    </row-col-component>

                    <row-col-component :class-row-col="'col-xxl-2 col-xl-3 col-lg-3 col-md-12 col-sm-12 col-12'">
                        <label>Status:</label>
                        <multiselect v-model="formDate.status" :searchable="true" :options="selectInput"
                                     :noResultsText="noResultsText" :noOptionsText="noResultsText"/>
                    </row-col-component>

                    <row-col-component :class-row-col="'col-xxl-2 col-xl-3 col-lg-3 col-md-12 col-sm-12 col-12'">
                        <label>Tipo de Mídia:</label>
                        <multiselect v-model="formDate.type" :searchable="true" :options="selectTypeMedia"
                                     :noResultsText="noResultsText" :noOptionsText="noResultsText"/>
                    </row-col-component>

                    <row-col-component :class-row-col="'col-xxl-3 col-xl-3 col-lg-3 col-md-12 col-sm-12 col-12'">
                        <label>Segmento:</label>
                        <multiselect v-model="formDate.segment" :searchable="true" :options="selectSpotSegment"
                                     :noResultsText="noResultsText" :noOptionsText="noResultsText"/>
                    </row-col-component>

                    <row-col-component
                            :class-row-col="'col-xxl-2 col-xl-2 col-lg-2 col-md-12 col-sm-12 col-12 mt-0 mt-xxl-4'">
                        <button-one class="mx-1" @submit="submit" :icon="'search'"/>
                        <button-float class="mx-1" :itens="itensTwo" v-if="buttonCheck.create"/>
                    </row-col-component>
                </row-component>
            </transition>
        </form>

        <loder-send-component :text-title="'Carregando'" v-if="showLoader"/>

        <div v-else>
            <table class="table table-striped">
                <thead>
                <tr>
                    <th scope="col" style="width: 30%">Nome</th>
                    <th scope="col" style="width: 25%">Titulo</th>
                    <th scope="col" style="width: 25%">Status</th>
                    <th scope="col" style="width: 10%" v-if="buttonCheck.show || buttonCheck.edit">Ações</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="(data, index) in  objectReturn.data" :key="index">
                    <td data-label="Nome">{{ data.name }}</td>
                    <td data-label="Título">{{ data.title }}</td>
                    <td data-label="Status">{{ statusString(data.status) }}</td>
                    <td data-label="Ações" v-if="buttonCheck.show || buttonCheck.edit">
                        <button-show-round :route="'spots-show'" :id-param="data.id" v-if="buttonCheck.show"/>
                        <button-edit-round :route="'spots-edit'" :id-param="data.id" v-if="buttonCheck.edit"/>
                    </td>
                </tr>
                </tbody>
            </table>

            <button-pagination :pagination="objectReturn" :offset="3" @paginate="loadSpots"/>
        </div>
    </painel-component>
</template>

<script>
import ButtonPagination from "@/components/buttons/ButtonPagination";
import PainelComponent from "@/components/dashboard/PainelComponent";
import ButtonShowRound from "@/components/buttons/ButtonShowRound";
import ButtonEditRound from "@/components/buttons/ButtonEditRound";
import ButtonOne from "@/components/buttons/ButtonOne";
import ButtonFloat from "@/components/buttons/ButtonFloat";
import InputComponent from "@/components/form/InputComponent";
import RowComponent from "@/components/row/RowComponent";
import RowColComponent from "@/components/row/RowColComponent";
import LoderSendComponent from "@/components/LoderSendComponent";
import Multiselect from "@vueform/multiselect";

import {useToast} from "vue-toastification";

const toast = useToast();

export default {
    name: "SpotsSearch",
    components: {
        ButtonShowRound,
        ButtonEditRound,
        ButtonPagination,
        PainelComponent,
        ButtonOne,
        ButtonFloat,
        InputComponent,
        RowComponent,
        RowColComponent,
        LoderSendComponent,
        Multiselect,
    },

    created() {
        this.$store.dispatch('updateNamePage', 'Pontos')
        this.$store.dispatch('loadSpotSegmentList')
        this.loadSpots(1)
        this.resizeWindow()
        this.checkACL()
    },

    data() {
        return {
            itensOne: {
                title: "Pesquisa",
                icon: "list alternate"
            },

            itensTwo: {
                route: "/spots/create",
                icon: "plus",
                name: ''
            },

            buttonCheck: {
                edit: false,
                create: false,
                show: false
            },

            formDate: {
                name: '',
                type: '',
                segment: '',
                status: 1,
            },

            filter: true,
            btnFilter: false,
            showLoader: true,
            searchSubmit: false,
        }
    },

    methods: {
        submit() {
            this.loadSpots(1)
            this.searchSubmit = true;
        },

        loadSpots(page) {
            this.showLoader = true
            if (!this.searchSubmit) {
                this.$store.dispatch('loadSpots', {...this.params, page})
                    .then((r) => {
                        this.showLoader = false
                        if (this.searchSubmit) {
                            this.searchSubmit = false;
                            if (r.data.length === 0) {
                                toast.info("Nada foi encontrado com os parâmetros informados!", {timeout: 10000});
                            }
                        }
                    }).catch(() => {
                    this.showLoader = false
                    this.searchSubmit = false;
                });
            }
        },

        async checkACL() {
            this.$store.dispatch('ACLitens', 29)
                .then((r) => {
                    if (r.data.indexOf('spot-search') !== -1) {
                        this.showLoader = false

                        if (r.data.indexOf('spot-create') !== -1) {
                            this.buttonCheck.create = true
                        }

                        if (r.data.indexOf('spot-edit') !== -1) {
                            this.buttonCheck.edit = true
                        }

                    } else {
                        this.$router.push({name: 'home'})
                    }
                }).catch(() => {
                this.$router.push({name: 'home'})
            })
        },

        statusString(value) {
            if (parseInt(value) === 1)
                return 'Ativo'
            return 'Inativo'
        },

        filterWindow() {
            this.filter = !this.filter
        },

        resizeWindow() {
            if (window.innerWidth <= 991) {
                this.filter = false
                this.btnFilter = true
            } else {
                this.filter = true
                this.btnFilter = false
            }
        },
    },

    computed: {
        noResultsText() {
            return this.$store.state.var.selectNotSearch
        },

        selectSpotSegment() {
            return this.$store.state.var.selectSpotSegment
        },

        selectTypeMedia() {
            return this.$store.state.var.selectTypeMedia
        },

        selectInput() {
            return this.$store.state.var.selectActiveInactive
        },

        objectReturn() {
            return this.$store.state.spots.items
        },

        params() {
            return {
                page: this.objectReturn.current_page,
                name: this.formDate.name,
                type: this.formDate.type,
                segment: this.formDate.segment,
                status: this.formDate.status,
            }
        },
    },
}
</script>

<style scoped src="@/assets/css/table-resp.css"></style>